function Progress({ index, numQuestions, points, maxPossiblePoints, answers }) {
  return (
    <header className="progress">
      <progress
        max={numQuestions}
        value={answers.filter((answer) => answer != null).length}
      />

      <p>
        Questions <strong>{index + 1}</strong> / {numQuestions}
      </p>

      <p>
        <strong>{points}</strong> / {maxPossiblePoints}
      </p>
    </header>
  );
}

export default Progress;
